import * as userActions from "./actions/user";
import get from "lodash.get";
import ICharity from "../types/services/ICharity";

const actors = (state, dispatch) => {
  let charities = [...state.user.charities];
  let shouldUpdate = false;
  charities.forEach((charity, index) => {
    if (
      !get(state.firebase, `data.${charity.id}.info.name`) &&
      !get(state.firebase, `data.${charity.id}.info.adminName`)
    ) {
    } else if (!charity.name) {
      shouldUpdate = true;
      let adminName = get(state.firebase, `data.${charity.id}.info.adminName`);
      let name = get(state.firebase, `data.${charity.id}.info.name`);
      charities[index].name = adminName ? adminName : name;
    }
    if (
      typeof get(state.firebase, `data.${charity.id}.config.disableGive`) ===
      "undefined"
    ) {
    } else if (
      typeof get(state.firebase, `data.${charity.id}.config.disableGive`) !==
        "undefined" &&
      get(state.firebase, `data.${charity.id}.config.disableGive`) !==
        charity.disableGive
    ) {
      shouldUpdate = true;
      charities[index].disableGive = get(
        state.firebase,
        `data.${charity.id}.config.disableGive`
      );
    }
  });
  if (shouldUpdate) {
    dispatch(userActions.updateCharities(charities));
  }

  const current = state.user.currentCharity;
  if (!current?.id) {
    return;
  }

  const listed = charities.find(
    (charity: ICharity) => charity.id === current.id
  );
  if (!listed) {
    return;
  }

  let next: ICharity = current;
  if (!current.name && listed.name) {
    next = { ...next, name: listed.name };
  }
  if (
    typeof current.disableGive === "undefined" &&
    typeof listed.disableGive !== "undefined"
  ) {
    next = { ...next, disableGive: listed.disableGive };
  }
  if (next !== current) {
    dispatch(userActions.changeCurrentCharity(next));
  }
};

export default actors;
